import { memo } from 'react';
import { AnnotationType } from '../../../modules/Properties/types';
import { PropertyPanel } from '../../../modules/Properties/components/PropertyPanel';

interface StructurePropertiesProps {
  identifier: string;
  projectId: string;
}

/**
 * Right-panel for STRUCTURE annotations. Renders only the standard information
 * header; everything else (kind dropdown, height, etc.) comes from the
 * registered structure properties via the generic `PropertyPanel`.
 */
const StructureProperties_: React.FC2<StructurePropertiesProps> = ({ identifier, projectId }) => {
  return (
    <div className="flex flex-col space-y-4 divide-y divide-gray-800">
      <PropertyPanel projectId={projectId} annotationTypes={[AnnotationType.STRUCTURE]} objectIdentifiers={[identifier]} />
    </div>
  );
};

export const StructureProperties = memo(StructureProperties_);
